import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	loomVideosHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loomCardErrorHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	successTitleLinkInserted: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	successLinkInserted: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	successActionShare: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// TODO - finaliaze these messages
	failureTitleLinkInserted: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	failureLinkInserted: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	loomVideosHeading: {
		id: 'issue-view-base.content.loom-videos.loom-videos-heading',
		defaultMessage: 'Loom videos',
		description: 'Heading for loom videos section in Jira issue view',
	},
	loomCardErrorHeading: {
		id: 'issue-view-base.content.loom-videos.loom-card-error-heading',
		defaultMessage: 'An error has occurred',
		description:
			"A generic error message shown inside a Loom video card attached to a Jira issue when the video link can't be resolved",
	},
	successTitleLinkInserted: {
		id: 'issue-view-base.content.loom-videos.success-title-link-inserted',
		defaultMessage: 'Your Loom video has been added!',
		description: 'title for a notification flag when the user successfully inserted a loom video',
	},
	successLinkInserted: {
		id: 'issue-view-base.content.loom-videos.success-link-inserted',
		defaultMessage: 'Copy the link to share it with your team.',
		description:
			'description for a notification flag when the user successfully inserted a loom video',
	},
	successActionShare: {
		id: 'issue-view-base.content.loom-videos.success-action-share',
		defaultMessage: 'Copy link',
		description: 'the label on a button that copies a link to a loom video for sharing',
	},
	// TODO - finaliaze these messages
	failureTitleLinkInserted: {
		id: 'issue-view-base.content.loom-videos.failure-title-link-inserted.non-final',
		defaultMessage: 'Failed to add your Loom video',
		description:
			'title for a notification flag when the user tried to insert a loom video but the opration failed',
	},
	failureLinkInserted: {
		id: 'issue-view-base.content.loom-videos.failure-link-inserted.non-final',
		defaultMessage: 'Please try again.',
		description:
			'description for a notification flag when the user tried to insert a loom video but the opration failed',
	},
});
